export default {
  completedChecklists: [],
  completedChecklist: undefined,
};
